import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProductSettingMcItem, ProductSettingService } from '@app/services/product-setting.service';

@Component({
    selector: 'tt-product-setting-mcs-form-input',
    templateUrl: './product-setting-mcs-form-input.component.html',
    styleUrls: ['./product-setting-mcs-form-input.component.css'],
})
export class ProductSettingMcsFormInputComponent implements OnChanges {
    public get isTextInput(): boolean {
        return this.elementtype === 'T';
    }

    public get isTextAreaInput(): boolean {
        return this.elementtype === 'TL';
    }

    public get isNumberInput(): boolean {
        return /^N\d+/.test(this.elementtype ?? '');
    }

    public get isEditorInput(): boolean {
        return this.elementtype === 'HE';
    }

    public get isDropdownInput(): boolean {
        return this.elementtype === 'CL';
    }

    public get isCounterInput(): boolean {
        return this.elementtype === 'S1';
    }

    @Input()
    public productsettingMcKeyno: string | number = '';

    @Input()
    public elementtype: string = '';

    @Input()
    public get label(): string {
        return this._label;
    }
    public set label(value: string) {
        this._label = value;
    }
    private _label = '';

    @Input()
    public model: string = '';

    @Output()
    public modelChange = new EventEmitter<string>();

    @Input()
    public get required(): boolean {
        return this._required;
    }
    public set required(value: any) {
        this._required = [1, '1', true, 'true'].includes(value);
    }
    private _required: boolean = false;

    @Input()
    public get readonly(): boolean {
        return this._readonly;
    }
    public set readonly(value: any) {
        this._readonly = [1, '1', true, 'true'].includes(value);
    }
    private _readonly = false;

    @Output()
    public blur = new EventEmitter<void>();

    @Input()
    public data: ProductSettingMcItem[] = [];

    @Input()
    public hideCounterAfterAssign = false;

    public get decimals(): number {
        return this._decimals;
    }
    public set decimals(value: any) {
        this._decimals = !!value && /^N\d+/.test('' + value || '') ? +value.substring(1) : !!value && !isNaN(+value) ? +value : 0;
    }
    private _decimals: number = 0;

    public numberAssigned = false;

    constructor(private productSetting: ProductSettingService) {}

    public async loadNextCounter() {
        this.model = (await this.productSetting.getProductCreateMetaColumnCounter({ productsettingmc_keyno: this.productsettingMcKeyno }))?.nextnumber ?? '0';
        this.modelChange.emit(this.model);
        this.blur.emit();
        this.numberAssigned = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['required']) {
            this.required = changes['required'].currentValue;
        }

        if (changes['readonly']) {
            this.readonly = changes['readonly'].currentValue;
        }

        if (changes['elementtype']) {
            this.decimals = changes['elementtype'].currentValue;
        }
    }
}
